export const environment: any = {
  production : true,
  apiUrl: 'https://localhost:7070/api',
  osanoScriptUrl: 'https://cmp.osano.com/RsWhaLkmW8/ee47a63f-f01d-45be-8d3c-db325751b437/osano.js'
};
